module.exports = __webpack_public_path__ + "img/mdi_linkedin.cabfb1fe.svg";